<template> 
<div class="panel">
    <div>
        <Row type="flex" justify="start" :gutter="4">
            <Col span="24">
                <Row type="flex" justify="start"> 
                    <Col  style="width:100%">
                    <div>
                        <Card :id="config.name" :bordered="false">
                            <p  v-if="config.title !== undefined"  slot="title">
                                {{config.title}}
                            </p>    
                            <FormBox ref="form" :config="config" :dictData="dictData"/>
                            <hr style="margin-top: 15px;margin-bottom: 15px;background-color: #dcdee2;height: 1px;border: none;"/>
                            <Tabs value="bmemberactheadprojects">
                                    <TabPane v-for="detail in config.detail" :label="detail.title" :name="detail.name">
                                    <EditGrid :ref="detail.name" :config="detail" :dictData="dictData"> </EditGrid>
                                    </TabPane>    
                            </Tabs>
                        </Card>
                    </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
</div>
</template>
<script>
    import toolAnchor from './toolanchor';
    import comPro from './formcompro';
    export default {
        name: 'ocmformdetail',
        mixins: [comPro,toolAnchor],
        data (){
            return {
                alonePictureConfig:{},
                showAlonePicture:false,
                anchorTop:70,
                alonePictureValue:{},
                hackReset:true

            };
        },
        created () {
            this.init();
        },
        methods:{
            init() {
                this.addAnchor(this.config.name,this.config.title);
                if (this.config.detail) {
                    const length2 =this.config.detail.length;
                    for(let j=0;j<length2;j++){
                        this.addAnchor(this.config.detail[j].name,this.config.detail[j].title);
                    }
                }
                /* const index = this.config.items.findIndex(obj => obj.type ==='PictureBox' && obj.visible === false && obj.showStyle === 'alone');
                if (index > -1) {
                    this.alonePictureConfig = this.$Method.copy(this.config.items[index]);
                    this.alonePictureValue[this.alonePictureConfig.name]='';
                    this.anchorTop = 70;
                    this.showAlonePicture = true;
                } else {
                    this.alonePictureConfig={};
                    this.alonePictureValue={};
                    this.anchorTop = 0;
                    this.showAlonePicture = false;
                } */
               
            },
            
            getDetailData(name){
                if (this.$refs[name] && this.$refs[name].length > 0) {
                    return this.$refs[name][0].getData();
                } else {
                    return [];
                }     
            },
            setDetailData(name,data){
                if (this.$refs[name] && this.$refs[name].length > 0) {
                    this.$refs[name][0].setData(data);
                } 
            },
            clearDetailData() {
                const length = this.config.detail.length;
                for (let i=0; i<length; i++) {
                    let name = this.config.detail[i].name;
                    if (this.$refs[name] && this.$refs[name].length > 0) {
                        this.$refs[name][0].clearData();
                    }     
                }
            },
            setAllDetailData(obj) {
                const length = this.config.detail.length;
                for (let i=0; i<length; i++) {
                    let name = this.config.detail[i].name;
                    if (obj[name]) {
                        this.setDetailData(name,obj[name]);
                    }
                }
            },
           
            setDetailReadOnly(value) {
                const length = this.config.detail.length;
                for (let i=0; i<length; i++) {
                    let name = this.config.detail[i].name;
                    if (this.$refs[name] && this.$refs[name].length > 0) {
                        this.$refs[name][0].setReadOnly(value);
                    }     
                }
            },
            updateRow(name,index,obj){
                if (this.$refs[name] && this.$refs[name].length > 0) {
                    this.$refs[name][0].updateRow(index,obj);
                }     
            },
            getAllDetailData() {
                const length = this.config.detail.length;
                let obj = {};
                for (let i=0; i<length; i++) {
                    let name = this.config.detail[i].name;
                    obj[name] = this.getDetailData(name);
                }
                return obj;
            },
            getData(){
                const form = this.$refs.form.getData();
                return Object.assign({},form,this.getAllDetailData());
            },
            clearData() {
                //清空主表的数据与检验
                this.$refs.form.clearData();
                
                 
                //清空明细的数据
                this.clearDetailData();
            },
            setFormReadOnly(value) {
                //设置主表是否编辑
                this.$refs.form.setFormReadOnly(value);
                //设置图片是否可编辑
                // this.$refs.picture.setReadOnly(value);
                //设置明细表是否编辑
                this.setDetailReadOnly(value);
            },
            getValue(name) {
                return this.$refs.form.getValue(name);
            },
            setValue(name,value){
                this.$refs.form.setValue(name,value);
            },
            setPro(name,value) {
                this.$refs.form.setPro(name,value);
            },
            getPro(name,pro) {
                return this.$refs.getPro(name,pro);
            },
            setReadOnly(name,value) {
                this.$refs.form.setReadOnly(name,value);
                if (name === this.alonePictureConfig.name) {
                    let pro = {};
                    pro.readOnly = value;
                    this.$refs.picture.setReadOnly(pro);
                } 
            },
            isError() {
                return this.$refs.form.isError();
            },
            setData(obj){
                //设定主表的数据
                this.$refs.form.setData(obj);
                //设定LOGO的值
                /* if (this.showAlonePicture) {
                    let  objPicture = {};
                    objPicture[this.alonePictureConfig.name] = obj[this.alonePictureConfig.name];
                    this.alonePictureValue = objPicture;
                    this.reset();
                } */
                
                //设定明细的数据
                this.setAllDetailData(obj);
            },
            inputPicture(obj) {
                this.$refs.form.setValue(obj.name, obj.value);
            },
            checkValidate() {
                this.$refs.form.checkValidate();
            },
            isChange () {
                return this.$refs.form.isChange();
            },
            reset() {
                this.hackReset = false;
                if (!this.hackReset) {
                    this.$nextTick(() => {
                        this.hackReset = true;
                        this.$nextTick(() => {
                            let pro = {};
                            pro.readOnly = true;
                            this.$refs.picture.setReadOnly(pro);
                        });
                    });
                }
            },
            getChangeData() {
                let form = this.$refs.form.getData();
                if (this.config.detail && this.config.detail.length > 0) {
                    this.config.detail.forEach(el => {
                        if (this.$refs[el.name] && this.$refs[el.name].length > 0) {
                            form[el.name] = this.$refs[el.name][0].getChangeData();
                        }
                    });
                }
                return form;
            }
        }
    };
</script>

<style>
 .panel .ivu-table {
     font-size: 12px;
 }
 .ivu-table {
     font-size: 12px;
 }
</style>




// WEBPACK FOOTER //
// src/components/form/ocmformdetail.vue